import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeNavMenu } from '../features/NavMenu';

import { RiGovernmentLine } from 'react-icons/ri';
import { PiMoneyWavy } from 'react-icons/pi';
import { TbWorld } from 'react-icons/tb';
import { MdSportsSoccer, MdCurrencyExchange } from 'react-icons/md';
import { FaMicrochip } from 'react-icons/fa6';

export default function NavMenu({ headerHeight }) {
  const navMenu = useSelector((state) => state.navMenu.value);
  const dispatch = useDispatch();

  const sourceCountry = 'argentina';
  const language = 'es';

  const routes = {
    argentina: [
      {
        route: '/sections/politics',
        routeName: {
          es: 'Politíca',
          it: 'Politica',
        },
        icon: <RiGovernmentLine />,
      },
      {
        route: '/sections/economy',
        routeName: {
          es: 'Economía',
          it: 'Economia',
        },
        icon: <PiMoneyWavy />,
      },
      {
        route: '/sections/internationals',
        routeName: {
          es: 'Internacionales',
          it: 'Esteri',
        },
        icon: <TbWorld />,
      },
      {
        route: '/sections/sports',
        routeName: {
          es: 'Deportes',
          it: 'Sport',
        },
        icon: <MdSportsSoccer />,
      },
      {
        route: '/sections/technology',
        routeName: {
          es: 'Tecnología',
          it: 'Tecnologia',
        },
        icon: <FaMicrochip />,
      },
      {
        route: '/sections/exchange',
        routeName: {
          es: 'Cotizaciones',
        },
        icon: <MdCurrencyExchange />,
      },
    ],
    italy: [],
  };

  useEffect(() => {
    const handleScroll = () => {
      if (navMenu.isOpen) {
        dispatch(closeNavMenu());
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [navMenu.isOpen, dispatch]);

  return (
    <div
      className={`z-30 border-r border-b border-[#34345c] rounded-br-md p-5 fixed bg-[#d6daf0] transition-all duration-300 ${
        navMenu.isOpen ? 'left-[0%]' : 'left-[-100%]'
      }`}
      style={{ marginTop: `${headerHeight}px` }}
    >
      <nav className="flex flex-col gap-3">
        {routes[sourceCountry].map((route, index) => (
          <li
            key={index}
            className="px-5 py-3 list-none border text-xl text-[#34345c] font-bold rounded-md border-[#34345c] bg-[#eef2ff]"
          >
            <a
              href={route.route}
              onClick={() => {
                dispatch(closeNavMenu());
              }}
              className="flex gap-5 items-center"
            >
              {route.icon}
              {route.routeName[language]}
            </a>
          </li>
        ))}
      </nav>
    </div>
  );
}
